module.exports = __webpack_public_path__ + "img/appstore.f5af39f4.svg";